import React from 'react';
import PropTypes from 'prop-types';

import Loading from './styles';

import {
	HeaderContainer,
	BrowseContainer,
	BrowseItem,
} from './styles';

const LoadingHeader = () => (
	<HeaderContainer>
		<Loading />
	</HeaderContainer>
)

const LoadingBrowse = ({ browseType }) => {
	const buildings = [];

	for (let i = 0; i < 100; i++) {
		buildings.push(<BrowseItem key={`browse-${i}`} browseType={browseType} />);
	}

	return (
		<BrowseContainer browseType={browseType}>
			{ buildings }
		</BrowseContainer>
	)
}

LoadingBrowse.propTypes = {
	browseType: PropTypes.string,
}

export {
	LoadingHeader,
	LoadingBrowse,
}

export default Loading
